module.exports = __webpack_public_path__ + "static/media/Logo2.721008b8.png";